import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
// typeform
import { Widget } from '@typeform/embed-react';
/**
 * Typeform renders a Typeform widget.
 */
export const Typeform = ({ className, formID, onSubmit }) => {
    return _jsx(StyledWidget, { className: className, id: formID, onSubmit: onSubmit });
};
const StyledWidget = styled(Widget) `
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 0;
  .tf-v1-widget iframe {
    border-radius: 0;
  }
`;
Typeform.displayName = 'Typeform';
export default Typeform;
